import * as types from "./mutation-type";
import { API_STATES } from "@/helpers";
import { findIndex } from "lodash";

const mutations = {
  [types.GET_JOBCODES_BEGIN](state) {
    state.jobCodesGetState = API_STATES.REQUEST_PENDING;
  },
  [types.GET_JOBCODES_SUCCESS](state, jobCodes) {
    state.jobCodesGetError = null;
    state.jobCodes = jobCodes;
    state.jobCodesGetState = API_STATES.REQUEST_SUCCESS;
  },
  [types.GET_JOBCODES_ERROR](state, err) {
    state.jobCodesGetState = API_STATES.REQUEST_ERROR;
    state.jobCodesGetError = err;
  },
  [types.DELETE_JOBCODE_BEGIN](state) {
    state.jobCodeDeleteState = API_STATES.REQUEST_PENDING;
  },
  [types.DELETE_JOBCODE_SUCCESS](state, id) {
    state.jobCodeDeleteError = null;
    state.jobCodeDeleteState = API_STATES.REQUEST_SUCCESS;
    const index = findIndex(state.jobCodes, function(o) {
      return o.id === id;
    });
    state.jobCodes.splice(index, 1);
  },
  [types.DELETE_JOBCODE_ERROR](state, err) {
    state.jobCodeDeleteState = API_STATES.REQUEST_ERROR;
    state.jobCodeDeleteError = err;
  },

  [types.ADD_JOBCODE_BEGIN](state) {
    state.jobCodeCreateState = API_STATES.REQUEST_PENDING
  },
  [types.ADD_JOBCODE_SUCCESS](state, jobcode) {
    state.jobCodeCreateError = null
    state.jobCode = jobcode
    state.jobCodeCreateState = API_STATES.REQUEST_SUCCESS
  },
  [types.ADD_JOBCODE_ERROR](state, err) {
    state.jobCodeCreateState = API_STATES.REQUEST_ERROR
    state.jobCodeCreateError = err
  },

  [types.UPDATE_JOBCODE_BEGIN](state) {
    state.jobCodeUpdateState = API_STATES.REQUEST_PENDING
  },
  [types.UPDATE_JOBCODE_SUCCESS](state, jobcode) {
    state.jobCodeUpdateError = null
    state.jobCode = jobcode
    state.jobCodeUpdateState = API_STATES.REQUEST_SUCCESS
  },
  [types.UPDATE_JOBCODE_ERROR](state, err) {
    state.jobCodeUpdateState = API_STATES.REQUEST_ERROR
    state.jobCodeUpdateError = err
  },
};

export default mutations;
